import KNB from '@dp/knb';

export function openAppLogin(url) {
    const link = `bizmeituan://e.meituan.com/login_webview_backhomepage?url=${encodeURIComponent(url)}`;
    setTimeout(() => location.href = link, 300);
}

export function gotoH5Link(from, to, replace, params) {
    let link = `${location.protocol}//${location.host}${location.pathname.replace(from, to)}`;
    if (params) link +=`?${params}`;
    setTimeout(() => {
        if (replace) {
            location.replace(link);
        } else {
            location.href = link;
        }
    }, 300);
}

export function openUrl(from, to, replace, params) {
    let link = `${location.protocol}//${location.host}${location.pathname.replace(from, to)}`;
    if (params) link +=`?${params}`;
    setTimeout(() => {
        if (replace && KNB.jumpWebview) KNB.jumpWebview({ url: link});
        else KNB.openWebview({ url: link});
    }, 300);
    
}


// WEBPACK FOOTER //
// ./lib/app.js